/* eslint-disable */
import React from 'react'
import ClassNames from 'classnames'
import { DragSource, DropTarget } from 'react-dnd'
import { NativeTypes } from 'react-dnd-html5-backend'
import { formatDistanceToNow } from 'date-fns'
import { DocumentTags } from '../../DocumentTags'
import BaseFile, { BaseFileConnectors } from './../base-file.js'
import { fileSize } from './utils.js'
import { flow } from 'lodash'

class RawTableFile extends BaseFile {
  render() {
    const {
      isDragging, isDeleting, isRenaming, isOver, isSelected,
      action, url, browserProps, connectDragPreview,
      depth, size, modified,
    } = this.props

    const icon = browserProps.icons[this.getFileType()] || browserProps.icons.File
    const inAction = (isDragging || action)

    const ConfirmDeletionRenderer = browserProps.confirmDeletionRenderer

    let name
    if (!inAction && isDeleting && browserProps.selection.length === 1) {
      name = (
        <ConfirmDeletionRenderer
          handleDeleteSubmit={this.handleDeleteSubmit}
          handleFileClick={this.handleFileClick}
          url={url}
        >
          {icon}
          {this.getName()}
        </ConfirmDeletionRenderer>
      )
    } else if (!inAction && isRenaming) {
      name = (
        <form className="renaming" onSubmit={(event) => {
          event.stopPropagation()
          this.handleRenameSubmit(event)
        }}
        >
          {icon}
          <input
            ref={this.selectFileNameFromRef}
            type="text"
            value={this.state.newName}
            onChange={this.handleNewNameChange}
            onBlur={this.handleCancelEdit}
            autoFocus
          />
        </form>
      )
    } else {
      name = (
        <a
          href={url || '#'}
          download="download"
          onClick={this.handleFileClick}
        >
          {icon}
          {this.getName()}
        </a>
      )
    }

    let draggable = (
      <div>
        {name}
      </div>
    )

    let documentTags = this.getDocumentTags()
    let allTags = this.getAllTags()

    if (typeof browserProps.moveFile === 'function') {
      draggable = connectDragPreview(draggable)
    }

    const isBeingCreated = this.getIsBeingCreated()

    const row = (
      <tr
        className={ClassNames('file', {
          pending: action,
          dragging: isDragging,
          dragover: isOver,
          selected: isSelected,
        })}
        onClick={!isBeingCreated && this.handleItemClick}
        onDoubleClick={!isBeingCreated && this.handleItemDoubleClick}
      >
        <td className={isBeingCreated ? 'bp3-skeleton  file-uploading' : 'name'}>
          <div style={{ paddingLeft: (depth * 16) + 'px' }}>
            {isBeingCreated
              ? <>... uploading {this.getName()}</>
              : draggable}
          </div>
        </td>
        <td className={isBeingCreated ? 'bp3-skeleton' : 'tags'}>
          {!isBeingCreated &&
            <DocumentTags documentId={this.getDocumentId()} documentTags={documentTags}
              allTags={allTags} addTag={this.handleAddTag} removeTag={this.handleRemoveTag}
            />}
        </td>
        <td className={isBeingCreated ? 'bp3-skeleton' : 'modified'}>
          {(typeof modified === 'undefined' || !modified || modified.toString == 'Invalid Date') ? '-' : formatDistanceToNow(modified, { addSuffix: true })}
        </td>
      </tr>
    )
    return this.connectDND(row)
  }
}


const TableFile = flow(
  DragSource('file', BaseFileConnectors.dragSource, BaseFileConnectors.dragCollect),
  DropTarget(
    ['file', 'folder', NativeTypes.FILE],
    BaseFileConnectors.targetSource,
    BaseFileConnectors.targetCollect
  ))(RawTableFile)

export default TableFile
export { RawTableFile }
